import { useEffect } from "react";
import { Game } from "@tumbodash/clientGameEngine";
import { log } from "@tumbodash/browserPackages";

let initialized = false;

function Debug() {
	useEffect(() => {
		log.fx("(debug)");
		if (initialized) return;
		initialized = true;

		async function initGame() {
			await Game.debug();
		}
		initGame();

		return () => {
			log.fx("(debug) - Unmounting");
		};
	}, []);

	return (
		<div className="mt-5 text-white text-center h5">
			Tumbodash Debug
		</div>
	);
}

export default Debug;
